import type { MessageDescriptor } from '@lingui/core';
import { BackendErrorCode, describeApiError, isDuplicateRequest, toApiError } from 'shared/errors';

/**
 * Текст отказа сохранения заявок игроков (`upsertChampionshipApplication` и
 * `upsertChampionshipApplicationUser`).
 *
 * `7016 USER_ALREADY_ACCEPTED_IN_ANOTHER_TEAM` (IMGM-1524 бэкенда): игрока подтверждают (`ACCEPTED`),
 * а он уже подтверждён в другой команде этого же соревнования. Ничего не сохраняется — пакетный
 * запрос откатывается целиком. В `message` — **готовый русский текст** с ФИО игрока и названием
 * команды; он точнее общего текста реестра, поэтому показывается как есть (он не английский —
 * решение «только переведённые» IMGM-1549 не нарушает). Конфликт в нём всегда один, даже если
 * конфликтных игроков несколько.
 *
 * `15 IDEMPOTENCY` — повтор того же запроса, не отказ: текста нет (`undefined`), показывать нечего.
 *
 * Остальные отказы — заголовок места вызова + причина из реестра (`shared/errors`), по коду.
 */
export function describeApplicationSaveError(error: unknown, title: MessageDescriptor): string | undefined {
  if (isDuplicateRequest(error)) return undefined;
  const { code, message } = toApiError(error);
  if (code === BackendErrorCode.USER_ALREADY_ACCEPTED_IN_ANOTHER_TEAM && message.trim() !== '') return message;
  return describeApiError(error, title);
}
